<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="CMSOverview")
    h1.title Alle Komponenten
    .sub-headline Hier können Sie alle Komponenten verwalten.
    
    .button-wrapper.margin-top      
      b-button(type="is-light" icon-left="plus" @click="$router.push({name: 'CMSBlockModelNew'})") Neue Komponente anlegen

    .card.margin-top
      .main
        b-table(:data="blockModels"
                default-sort-direction="asc"
                default-sort="createdAt"
                hoverable
                @click="row => $router.push({ name: 'CMSBlockModelEdit', params: { id: row.id } })")
          b-table-column(field='name' label='Name' sortable, v-slot="props")
            | {{props.row.name}}
          b-table-column(field='updatedAt' label='letzte Aktualisierung' sortable, v-slot="props")
            | {{formatDate(props.row.updatedAt)}}
          b-table-column(field='createdAt' label='erstellt am' sortable, v-slot="props")
            | {{formatDate(props.row.createdAt)}}
          b-table-column(v-slot="props")
            div
              b-tooltip(label='Bearbeiten' type='is-secondary' position='is-bottom' :delay="1250")
                b-button(icon-right="pencil", type="is-secondary" @click="$router.push({ name: 'CMSBlockModelEdit', params: { id: props.row.id } })")
              .spacer.sm.inline
              b-tooltip(label='Dauerhaft löschen' type='is-danger' position='is-bottom' :delay="1250")
                b-button(icon-right="close", type="is-danger" @click="deleteBlockModel(props.row)")
</template>

<script>
import { DateTime } from 'luxon';

export default {
  data() {
    return {
    };
  },
  computed: {
    blockModels() {
      return this.$store.state.blockModels.all;
    },
  },
  methods: {
    deleteBlockModel(row) {
      this.$buefy.dialog.confirm({
        title: "Komponente löschen",
        message: `Sind Sie sicher, dass Sie diese Komponente <b>${row.internalName}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Komponente löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            console.log("Löscht");
            // await this.$store.dispatch("promotions/delete", { id: row.id });
          } catch (e) {
            this.$store.dispatch(
              "common/showError",
              "Komponente konnte nicht gelöscht werden."
            );
          }
        }
      });
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd. LLL. yy")
    }
  },
  mounted() {
    this.$store.dispatch("blockModels/findAll");
  }
};
</script>

<style lang="scss" scoped>
.icon-name {
  margin-left: $sm-space;
}
</style>